/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_VinylInputs */

const en_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinyl`)
};

const es_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinilo`)
};

const fr_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinyle`)
};

const de_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinyl`)
};

const ja_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコード (バイナル)`)
};

const zh_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黑胶唱片`)
};

const ar_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فينيل (اسطوانات)`)
};

const id_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinyl`)
};

const it_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinile`)
};

const ru_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Винил`)
};

const pt_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinil`)
};

const ko_val_vinyl = /** @type {(inputs: Val_VinylInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`바이닐 (LP)`)
};

/**
* | output |
* | --- |
* | "Vinyl" |
*
* @param {Val_VinylInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_vinyl = /** @type {((inputs?: Val_VinylInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_VinylInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_vinyl(inputs)
	if (locale === "es") return es_val_vinyl(inputs)
	if (locale === "fr") return fr_val_vinyl(inputs)
	if (locale === "de") return de_val_vinyl(inputs)
	if (locale === "ja") return ja_val_vinyl(inputs)
	if (locale === "zh") return zh_val_vinyl(inputs)
	if (locale === "ar") return ar_val_vinyl(inputs)
	if (locale === "id") return id_val_vinyl(inputs)
	if (locale === "it") return it_val_vinyl(inputs)
	if (locale === "ru") return ru_val_vinyl(inputs)
	if (locale === "pt") return pt_val_vinyl(inputs)
	return ko_val_vinyl(inputs)
});